var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6462_18411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.25 22.1248C44.25 25.9408 44.0471 29.6455 43.674 33.18C43.3009 36.7146 40.6696 39.1888 37.3053 39.5488C33.7773 39.9284 30.0725 40.1248 26.25 40.1248C22.4275 40.1248 18.7293 39.9218 15.1947 39.5488C11.6602 39.1757 9.186 36.5444 8.826 33.18C8.44636 29.652 8.25 25.9473 8.25 22.1248C8.25 18.3022 8.45291 14.604 8.826 11.0695C9.19909 7.53494 11.8304 5.06076 15.1947 4.70076C18.7227 4.32112 22.4275 4.12476 26.25 4.12476C30.0725 4.12476 33.7707 4.32766 37.3053 4.70076C40.8398 5.07385 43.314 7.70512 43.674 11.0695C44.0536 14.5975 44.25 18.3022 44.25 22.1248Z",
    fill: "url(#paint0_radial_6462_18411)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 16.0807H20.625C20.3266 16.0807 20.0405 16.1992 19.8295 16.4102C19.6185 16.6212 19.5 16.9073 19.5 17.2057V21.338C19.5 27.6387 24.8311 29.729 25.8984 30.0841C26.1264 30.1616 26.3736 30.1616 26.6016 30.0841C27.6703 29.729 33 27.6387 33 21.338V17.2057C33 16.9073 32.8815 16.6212 32.6705 16.4102C32.4595 16.1992 32.1734 16.0807 31.875 16.0807ZM29.4605 20.9787L25.523 24.9162C25.4707 24.9685 25.4087 25.0099 25.3404 25.0383C25.2721 25.0666 25.1989 25.0811 25.125 25.0811C25.0511 25.0811 24.9779 25.0666 24.9096 25.0383C24.8413 25.0099 24.7793 24.9685 24.727 24.9162L23.0395 23.2287C22.934 23.1231 22.8747 22.98 22.8747 22.8307C22.8747 22.6814 22.934 22.5383 23.0395 22.4327C23.1451 22.3272 23.2882 22.2679 23.4375 22.2679C23.5868 22.2679 23.7299 22.3272 23.8355 22.4327L25.125 23.7223L28.6645 20.1827C28.7168 20.1305 28.7788 20.089 28.8471 20.0607C28.9154 20.0324 28.9886 20.0179 29.0625 20.0179C29.1364 20.0179 29.2096 20.0324 29.2779 20.0607C29.3462 20.089 29.4082 20.1305 29.4605 20.1827C29.5127 20.235 29.5542 20.297 29.5825 20.3653C29.6108 20.4336 29.6253 20.5068 29.6253 20.5807C29.6253 20.6546 29.6108 20.7278 29.5825 20.7961C29.5542 20.8644 29.5127 20.9264 29.4605 20.9787Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6462_18411",
    x: 0.000513077,
    y: 0.0000123978,
    width: 52.499,
    height: 52.499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.12474
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.12474
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495192 0 0 0 0 0.5625 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6462_18411"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6462_18411",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6462_18411",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.25 47.3794) rotate(-90) scale(66.3949)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65EF88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711538,
    stopColor: "#33C599"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.910f182e920cf5bf818a445c28178883.svg";
export { ForwardRef as ReactComponent };